import React, { Component } from 'react';
import Check from './Check';
import { judgeArr } from '@/shared/functions';
import { Row, Col } from 'antd';
class CheckGroup extends Component {
    constructor() {
        super(...arguments);
        this.onChange = (e) => {
            const { label, checked } = e;
            const valueDeal = JSON.parse(JSON.stringify(this.props.value));
            const index = valueDeal.findIndex((v) => (v === label));
            if (!!checked && index === -1) {
                valueDeal.push(label);
            }
            else if (!checked && index !== -1) {
                valueDeal.splice(index, 1);
            }
            this.props.onChange(valueDeal);
        };
        this.getRows = (options) => {
            const rowLen = Math.ceil(options.length / 3);
            const rows = [];
            for (let i = 0; i < rowLen; i += 1) {
                const row = [];
                if (options[i * 3]) {
                    row.push(options[i * 3]);
                }
                if (options[i * 3 + 1]) {
                    row.push(options[i * 3 + 1]);
                }
                if (options[i * 3 + 2]) {
                    row.push(options[i * 3 + 2]);
                }
                rows.push(row);
            }
            return rows;
        };
        this.checkRow = (value, checkItem, i) => {
            return (<Check key={`checkItem_${i}`} item={checkItem} checked={value.includes(checkItem.value)} onChange={this.onChange}/>);
        };
    }
    render() {
        const { options, value, className, isGrid } = this.props;
        const rows = this.getRows(options);
        return (<div className={className}>
                {judgeArr(options) && !isGrid &&
            <React.Fragment>
                        {options.map((checkItem, i) => (this.checkRow(value, checkItem, i)))}
                    </React.Fragment>}
                {judgeArr(options) && isGrid &&
            rows.map((row, j) => (<Row key={`row_${j}`}>
                        {row.map((item, i) => (<Col key={`col_${i}`} span={8}>
                              {this.checkRow(value, item, i)}
                            </Col>))}
                      </Row>))}
            </div>);
    }
}
export default CheckGroup;
